module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_rounded_shadow.12fa94e1.png";